$(function(){

  $('.buttonReset').click(
    function(){
    	$('.cpb-reset-button').click();  
    }
  );

  
  
  var cpbCustomApp = {
    elems: {
      builder: null 
    },
    selectors: {        
      'addToCart': '.cpb-product-actions-container .cpb-add-to-cart-button',        
    },
    mode: 0,
    productId: null,
    init: function() {        
      
     
      
      this.elems.builder = $('#product-builder');       
      this.setMode();
      this.addListener();     
      
      startNavagition();
      
    },
    setMode: function() {
      
     
      
      var paramsStr = decodeURI(window.location.search).replace('?', '');
      var arrParams, i, param;
      if(! paramsStr.match('/is_del/gi')) {
        arrParams = paramsStr.split('&');           
        for(i = 0; i < arrParams.length; i++) {
          param = arrParams[i].split('=');
          if(param.length <= 1) {
            continue;
          }
          if(param[0] == 'is_del') {
            this.mode = parseInt(param[1]);
            if(isNaN(this.mode)) {
              this.mode = 0;
            }
          } else if(param[0] == 'product_id') {
            this.productId = param[1];
          }                
        }
      }
    },
    addListener: function() {
      
      var app = this; 
      if ((app.mode == 1) && (app.productId)) {
        app.elems.builder.on('click', app.selectors.addToCart, function(){
          var data = {};
          data[app.productId] = 0;                
          $.post('/cart/update.js', {
            updates: data,
          });
        });
      }
    },
  };


  var cpbLoaded = function() {
    if (jQuery('.cpb-product-actions').length > 0) {

      cpbCustomApp.init();

      var stepsTot = $('.hamburgerPopup a').length;
      // var body = $('body')  
       
      var txt = `<div class="step-ind"><span class="step-active">1</span>/<span>${stepsTot}</span></div>`
      setTimeout( function() { 
          $(txt).appendTo('.newTabNavigation')  
      },100);    

    } else {
      window.requestAnimationFrame(cpbLoaded);
    }   
  };
  cpbLoaded();
  
  

  
});


function startNavagition(){

  var price = $('#pricedata').data('price');
   $('span[data-testid="multycurrency-price"]').text('€'+price);
  
    //$('.cpb-product-price span').addClass('money');    

  	$('.react-tabs__tab-list').after('<div class="newTabNavigation"></div>');
    $('.cpb-product-actions').before('<div class="navigationButtons"></div>');
  
	$('.react-tabs__tab-list').hide();
  
    $('.cpb-add-to-cart-button').hide();
    $('.cpb-next-tab-button span').empty();
    $('.cpb-next-tab-button span').text('Next Step');
  
  	$('.react-tabs__tab-list li').each(function(i,elem) {
      if($(elem).hasClass('cpb-active')){
        
            var prevElementName = '';
        	var nextElementName = $(elem).next().next().text();
            var activeElementId = $(elem).next().attr('id');
           	var activeElementName = $(elem).text();
               
        	buildNavigation(prevElementName, nextElementName, activeElementId, activeElementName);	
        	
      }
    
    });
  
    $('.cpb-add-to-cart-button').after('<div class="extraTextDelivery">* 10-15 days Delivery</div>');
  
}

function navigateTab(type){
  
   
  
	$('.react-tabs__tab-list li').each(function(i,elem) {
      if($(elem).hasClass('cpb-active')){
        
        if(type=='next'){
        	var prevElementName = $(elem).text();
        	var nextElementName = $(elem).next().next().text();
        	var activeElementId = $(elem).next().attr('id');
            var activeElementName = $(elem).next().text();
          
           
        }
        if(type=='prev'){
        	var prevElementName = $(elem).prev().prev().text();
        	var nextElementName = $(elem).text();
        	var activeElementId = $(elem).prev().attr('id');
            var activeElementName = $(elem).prev().text();
          
            
        }
        
        $('#' + activeElementId).click();
 
        buildNavigation(prevElementName, nextElementName, activeElementId, activeElementName);

        $("html, body").stop().animate({scrollTop:  $( ".cpb-panels-container" ).offset().top - (parseInt($('#jas-header').height())) }, 500, 'swing');

        return false;
      }
    
    });
}

function buildNavigation(Element1, Element2, newElementId, ActiveElement){
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    var trigerAction = 'onClick';
    if(iOS){
       trigerAction = 'ontouchstart';
    }
   
  	$('.newTabNavigation').empty();
    $('.navigationButtons').empty();
  
    var hamburgerpopup = '<div class="hamburgerPopup"></div>';
  
    var hamburgermenu = '<button onClick="humbMenuAction()" type="button" class="sc-bRBYWo iMRjak"><span class="sc-jlyJG sc-gipzik dinnXz"></span><span class="sc-jlyJG sc-csuQGl gxkCgp"></span><span class="sc-jlyJG sc-Rmtcm cpvzvT"></span></button>'+hamburgerpopup;
  	

    var prevButton = '<button style="cursor:pointer;" onClick="navigateTab(\'prev\');"  class="buttonsNextAndPrev"><span>Previous Step</span></button>';
    var nextButton = '<button style="cursor:pointer;" onClick="navigateTab(\'next\');"  class="buttonsNextAndPrev"><span>Next Step</span></button>';
  
  	$('.cpb-add-to-cart-button').hide();
    $('.extraTextDelivery').hide();
  
    
    
    if(Element1!='' && Element2!=''){
        $('.newTabNavigation').html(
            hamburgermenu + '<a class="prevNav" href="javascript:void(0)" onClick="navigateTab(\'prev\');" ><i class="text4">keyboard_arrow_left</i></a> <span class="currentTab">'+ActiveElement+'</span> <a  onClick="navigateTab(\'next\');"  class="nextNav" href="javascript:void(0)"><i class="text4">keyboard_arrow_right</i></a>'
        );
      	$('.navigationButtons').html(prevButton + ' ' + nextButton); 
    }else if(Element1=='' && Element2!=''){
        $('.newTabNavigation').html(
          hamburgermenu + '<a class="emptyLeftNav">|</a><span class="currentTab">'+ActiveElement+'</span> <a class="nextNav" onClick="navigateTab(\'next\');"  href="javascript:void(0)"><i class="text4">keyboard_arrow_right</i></a>'
        );
    
        $('.navigationButtons').html(nextButton); 
    }else if(Element1!='' && Element2==''){
        $('.newTabNavigation').html(
            hamburgermenu + '<a class="prevNav"  onClick="navigateTab(\'prev\');"  href="javascript:void(0)" ><i class="text4">keyboard_arrow_left</i> </a> <span class="currentTab">'+ActiveElement+'</span><a class="emptyRightNav">|</a>'
        );
      	$('.navigationButtons').html(prevButton); 
      
      	$('.cpb-add-to-cart-button').fadeIn(800);
        $('.extraTextDelivery').fadeIn(800);
    }
    

    
    $('.react-tabs__tab-list li').each(function(i,elem) {
       var extraClass = '';
       if($(elem).hasClass('cpb-active')){
       		extraClass = 'activeHambMenu';  
       }
           
      $('.hamburgerPopup').append('<a style="cursor:pointer;display:block;" href="javascript:void(0)"  onClick="goToTabBuilder(\'' + $(elem).attr('id') + '\');"  class="' + extraClass + '"  >' + $(elem).text() + '</a>');
    });  
  
 
    
}

function goToTabBuilder(idTab){
  var prevElementName   = $('#' + idTab).prev().text();
  var nextElementName   = $('#' + idTab).next().text();
  var activeElementId   = $('#' + idTab).attr('id');
  var activeElementName = $('#' + idTab).text();
  
  $('#' + activeElementId).click();
  
  buildNavigation(prevElementName, nextElementName, activeElementId, activeElementName);
}

function humbMenuAction(){
  	
 
  
  
  	 if($( "span.sc-gipzik" ).hasClass( 'dinnXz')){
       
        
       
     	$( "span.sc-gipzik" ).removeClass( 'dinnXz' );
        $( "span.sc-csuQGl" ).removeClass( 'gxkCgp' );
        $( "span.sc-Rmtcm" ).removeClass( 'cpvzvT' );
       
        $( "span.sc-gipzik" ).addClass( 'ixMiXW' );
        $( "span.sc-csuQGl" ).addClass( 'iaBMuh' );
        $( "span.sc-Rmtcm" ).addClass( 'gmuQXd' );
         
        $('.hamburgerPopup').fadeIn(800);
       
     }else{
         
       
     	$( "span.sc-gipzik" ).removeClass( 'ixMiXW' );
        $( "span.sc-csuQGl" ).removeClass( 'iaBMuh' );
        $( "span.sc-Rmtcm" ).removeClass( 'gmuQXd' );
       
        $( "span.sc-gipzik" ).addClass( 'dinnXz' );
        $( "span.sc-csuQGl" ).addClass( 'gxkCgp' );
        $( "span.sc-Rmtcm" ).addClass( 'cpvzvT' );
       
        
       
        $('.hamburgerPopup').fadeOut(600);
       
     }
  
    
}




    